module.exports = __webpack_public_path__ + "static/stores-track-5ce9712b9c6a8cb54b44a63a383512c3.png";